// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e38af7d6","455":"0a815f45","977":"abdb0408"}[chunkId] + ".chunk.js";
};